import { Component, Input } from "@angular/core";
import { ContactData } from "src/app/meta/ContactData.interface";

@Component({
    selector: "ow-order-summary-contact-data",
    templateUrl: "./order-summary-contact-data.component.html"
})
export class OrderSummaryContactDataComponent {

    @Input() contactData!: ContactData
    @Input() streetName!: string
    @Input() streetNumber!: string
    @Input() postalCode!: string
    @Input() city!: string

}
